'use client';

import NextLink from 'next/link';
import { useParams } from 'next/navigation';

type LandingLinkProps = React.ComponentProps<typeof NextLink>;

export function LandingLink({ href, ...props }: LandingLinkProps) {
  const params = useParams<{ locale?: string }>();
  const locale = params?.locale ?? 'en';
  const localizedHref =
    typeof href === 'string' && href.startsWith('/')
      ? href === '/'
        ? `/${locale}`
        : href.startsWith(`/${locale}/`)
          ? href
          : `/${locale}${href}`
      : href;

  return <NextLink href={localizedHref} {...props} />;
}
